import Image from "next/legacy/image";

export function OptimizedImage({ ...props }) {
  return (
    <>
      <div
        style={{
          width: `${props.width}px`,
          maxWidth: "100vw",
        }}
      >
        <div>
          <Image
            alt={props.alt ?? null}
            src={props.src}
            width={props.width}
            height={props.height}
            {...props}
          />
        </div>
      </div>
    </>
  );
}
